import React from "react";

interface DescriptionModalProps {
  show: boolean;
  description: string;
  onClose: () => void;
  onSave: () => void;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

const DescriptionModal: React.FC<DescriptionModalProps> = ({
  show,
  description,
  onClose,
  onSave,
  onChange,
}) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-xl">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-semibold">Additional Description</h2>
          <button onClick={onClose} className="text-black text-3xl">
            ×
          </button>
        </div>
        
        <div className="mb-4">
          <label className="block text-sm font-medium mb-2">
            Description <span className="text-red-500">*</span>
          </label>
          <textarea
            className="shadow appearance-none border border-[#D0D5DD] rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            rows={4}
            value={description}
            onChange={onChange}
            placeholder="mainland to island delivery"
          />
        </div>
        
        <div className="flex gap-4 justify-end">
          <button
            onClick={onClose}
            className="bg-white border border-gray-200 text-gray-700 font-medium py-2 px-12 rounded"
          >
            Cancel
          </button>
          <button
            onClick={onSave}
            className="bg-[#044E97] text-white font-medium py-2 px-12 rounded "
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default DescriptionModal;